import { I18n } from 'common'
import { ProductModel } from 'interfaces'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { getInterchangeParts } from '../../../../../../src/helpers/getInterchangeParts'
import { defaultTheme } from '../../../../../../src/theme/index'
import { MultiSellerInterchangeTooltip } from '../MultiSellerInterchangeTooltip'
import PartMessage from './PartMessage'
import { shouldShowMultiSellerTooltip } from './shouldShowMultiSellerTooltip'

interface SellerDetails {
  coverageKey?: string
}

interface ProductCardMobileLinksProps {
  hideRoutingDiagramContent: boolean
  partMessage?: string
  showTooltip: boolean
  setShowTooltip: (show: boolean) => void
  userId: string
  sellerDetails?: SellerDetails | null
  partNumber: string
  vehicleFitment: boolean
  replacementFor?: ProductModel
  alternateFor?: ProductModel
  showNonASTLinks: boolean
  onVehicleFitment: () => void
  onGfxCatalog: () => void
  showLaborLink: boolean
  onLaborLookup: () => void
  showAddToList: boolean
  onAddToList: () => void
}

export const ProductCardMobileLinks = ({
  hideRoutingDiagramContent,
  partMessage = '',
  showTooltip,
  setShowTooltip,
  userId,
  sellerDetails,
  partNumber,
  vehicleFitment,
  replacementFor,
  alternateFor,
  showNonASTLinks,
  onVehicleFitment,
  onGfxCatalog,
  showLaborLink,
  onLaborLookup,
  showAddToList,
  onAddToList,
}: ProductCardMobileLinksProps): ReactElement => {
  const showVehicleFitment =
    vehicleFitment && !replacementFor && !alternateFor && showNonASTLinks

  return (
    <MobileProductLinks>
      <PartMessage message={partMessage} />
      {!hideRoutingDiagramContent && (
        <>
          <div className="d-flex my-3 justify-content-start">
            <MultiSellerInterchangeTooltip
              show={
                showTooltip &&
                shouldShowMultiSellerTooltip(userId, sellerDetails)
              }
            >
              <LocalLink
                type="button"
                onClick={() => getInterchangeParts(partNumber, 'add')}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <I18n name="interchange" />
              </LocalLink>
            </MultiSellerInterchangeTooltip>

            {showVehicleFitment && (
              <LocalLink
                type="button"
                className="mx-3"
                onClick={onVehicleFitment}
              >
                <I18n name="vehicleFitment" />
              </LocalLink>
            )}
          </div>
          <LinkRow>
            <LocalLink type="button" onClick={onGfxCatalog}>
              <I18n name="gfxCatalog" />
            </LocalLink>

            {showLaborLink && (
              <LocalLink type="button" onClick={onLaborLookup}>
                <I18n name="labor" />
              </LocalLink>
            )}

            {showAddToList && (
              <LocalLink type="button" onClick={onAddToList}>
                <I18n name="addToList" />
              </LocalLink>
            )}
          </LinkRow>
        </>
      )}
    </MobileProductLinks>
  )
}

const MobileProductLinks = styled.div`
  display: flex;
  flex-direction: column;
  felx-wrap: wrap;
  align-items: flex-start;
  justify-content: flext-start;
`

const LocalLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: ${defaultTheme.colors.link};
  text-decoration: underline;
  cursor: pointer;
  margin: 10px 10px 0 0;
`

const LinkRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 8px;
  margin: 1rem 0;

  ${LocalLink} {
    margin: 0;
  }
`
